import { HrpBaseClient } from './HrpBaseClient'

export class HrpEnrollmentClient extends HrpBaseClient {
    constructor(
        hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
        hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
        axiosOptions
    ) {
        super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
    }

    async submitEnrollmentSparse(body) {
        await this.createSecureAxiosInstance()

        if (!body) {
            throw new Error('Invalid body payload');
        }

        try {
            const response = await this.secureAxiosInstance.post(
                `/admin/api/enrollment/v4/submitEnrollmentSparse`, 
                body
            );

            return response.data
        } 
        catch (e) {
            throw e.response
        }
    }
}
